import { render, staticRenderFns } from "./SamMockupModal.vue?vue&type=template&id=5c04676c&scoped=true&"
import script from "./SamMockupModal.vue?vue&type=script&lang=js&"
export * from "./SamMockupModal.vue?vue&type=script&lang=js&"
import style0 from "./SamMockupModal.vue?vue&type=style&index=0&id=5c04676c&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c04676c",
  null
  
)

export default component.exports